module.exports = __webpack_public_path__ + "static/media/doctor-search_p1_1.f9dee8a7.png";